// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.resume-container-41 {
  display: flex;
  flex-direction: column;
  padding: 20px;
  width: 1000px !important;
  justify-content: center;
  align-items: flex-end !important;
  margin: 0;
}

.resume41 {
  color: black;
}

.bold-title8 {
  font-weight: bold;
}
.bold8 {
  font-weight: 700;
  font-size: 14px;
}
.button-container123 {
  width: 78%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 10px 0;
  padding: 0 0rem 0 11rem;
}
.bk8 {
  justify-self: start;
}

.db823 {
  justify-self: end;
}
.db823 {
  background-color: #474559 !important;
  color: white !important;
  border: 2px solid black;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 8px;
  margin-left: 18rem;
  text-wrap: nowrap;
}
.back-button23 {
  position: relative;
  background-color: #474559 !important;
  color: #fff !important;
  border: 2px solid white;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  font-size: large;
  margin-top: 8px;
  left: 12px;
  display: block;
}

@media (max-width: 768px) {
  .db823 {
    padding-top: 0px !important;
    margin-left: 0px;
  }
  .button-container123 {
    padding: 0px;
    margin-left: 0px;
    align-items: flex-start;
  }
}


  @media (min-width: 768px) and (max-width: 1024px) {
    .db823 {
      padding-top: 0px !important;
      margin-left: 264px;
    }
    .button-container123 {
      padding: 0px;
      margin-left: 0px;
      align-items: flex-start;
    }
  }

  .resume41 {
    display: inline-block;
    flex-wrap: wrap;
    width: 100%;
    max-width: 800px;
    /* border: 1px solid rgb(5, 5, 93); */
    /* border-radius: 8px; */
    overflow: hidden;
    box-shadow: -1px 2px 24px rgba(0, 0, 0, 0.1);
  }
  .resume-container-8 {
    align-items: flex-start !important;
  }

.resume41 {
  display: flex;
  justify-content: space-around;

  flex-wrap: wrap;
  width: 100%;
  max-width: 800px;
  /* border: 1px solid rgb(5, 5, 93); */
  /* border-radius: 8px; */
  overflow: hidden;
  box-shadow: -1px 2px 24px rgba(0, 0, 0, 0.1);
  color: black;
}

.name41 {
  text-align: left;
  font-size: 3.6em;
  margin-top: 10px;
  font-weight: bold;
  color: black;
  text-transform: uppercase;
  margin-left: 30px;
}
.tc8 {
  text-align: left;
  font-size: 1.6em;
  font-weight: 300;
  color: black;
  text-transform: capitalize;
  margin-left: 30px;
}
.tc8::first-letter {
  text-transform: uppercase;
}
.jobtitle {
  display: inline-block;

  /* or display: block; */
}
.jobtitle23::first-letter {
  text-transform: uppercase !important;
}

.resume-left41 {
  background-color: white;
  position: relative;
  left: 11px;
  color: black;
  justify-content: space-between;
  padding: 20px;
  text-align: left;
  border: 3px solid rgb(5, 5, 93);
  margin-top: 22px;
  position: relative;
}

.section-title41 {
  font-size: 17px;
  margin-bottom: 9px;
  text-transform: uppercase;
  font-weight: 550;
  color: black;
}

.resume-right823 {
  background-color: white;
  color: black;
  padding: 20px;
  text-align: left;
  margin-top: 28px;
  text-wrap: wrap;
}
.p23 {
  font-family: 'Montserrat', sans-serif;
  font-size: 14px;
  color: black;
  word-wrap: break-word;
  text-align: justify;
}
.bold8 {
  font-weight: bold;
}
.resume-section823 {
  margin-bottom: 14px;
  margin-top: 50px;
}

.Contact-section {
  margin-top: 200px;
  /* padding: 20px; */
  width: 100%;
  font-size: 13px;
  margin-bottom: 10px;
  text-align: left;
  overflow-wrap: break-word !important;
  word-wrap: break-word !important; /* Alternative for compatibility */
  white-space: normal !important; /* Allows wrapping */
  max-width: 100%; /* Prevents the section from overflowing */
}

.Contact-section .d-flex23 {
  overflow-wrap: break-word !important;
  word-wrap: break-word !important; /* Alternative for compatibility */
  white-space: normal !important; /* Allows wrapping */
}

.Contact-section .section-title8 {
  font-size: 19px;
  font-weight: bold;
  text-transform: uppercase;
  color: black;
  margin-bottom: 10px;
}

.Contact-section p {
  font-size: 14px;
  color: black;
  line-height: 1.6;
  word-wrap: break-word;
}

.section-title8 {
  font-size: 1.2em;
  margin-bottom: 8px !important;
  color: black;
  margin-top: 0px !important;
  text-transform: uppercase;
  font-size: 19px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
}

.section-title1 {
  font-size: 19px;
  margin-bottom: 20px;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-weight: bold;
  color: black;
  text-transform: uppercase;
  margin-top: 28px;
}

.experience-item8,
.education-item823 {
  margin-bottom: 18px;
}

.resume-section823 ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.resume-section823 ul li {
  margin-bottom: 8px;
  align-items: center;
  font-size: 14px;
  color: black;
  text-wrap: wrap;
  text-align: justify;
  word-break: break-word;
  /* display:flex; */
}

.resume-section823 ul li span {
  margin-left: 14px;
}

.resume-section823 ul li ::before {
  content: "";
  position: absolute;
  top: 8px;
  left: -20px;
  width: 6px;
  height: 6px;
  border-radius: 80%;
  border: 2px solid black !important;
}
.icon8 {
  height: 17px;
  width: 17px;
  margin-right: 3px;
  color: black;
}
.subheading8 {
  color: black;
}
.p123 {
  font-weight: bold;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  margin: 4px 0;
  text-align: justify;
  text-wrap: wrap;
}
/* .p11 {
    font-weight: bold;
    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
    font-size: 14px;
    margin: 4px 0;
  
  } */

.p11 {
  font-weight: bold;
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  font-size: 14px;
  margin: 4px 0;
  display: flex;
}

.title1 {
  text-wrap: nowrap;
}
.span23 {
  font-size: 14px;
  font-weight: normal;
  line-height: 3px;
  color: black;
  text-wrap: wrap;
  text-align: justify;
}

.profile-pic41 img {
  width: 160px;
  height: 160px;
  border-radius: 0;
  border: 2px solid rgb(5, 5, 93);
  margin: 10px auto;
  justify-content: center !important;
  align-items: center !important;
  object-fit: cover;
  display: block;
  filter: contrast(2);
}

.profile-pic41 {
  margin-left: 110px;
  position: absolute;
  z-index: 1;
}
.experience-item8,
.education-item8 {
  position: relative;
  padding-left: 28px;
  border-left: 2px solid rgb(5, 5, 93);
  margin-bottom: 20px;
}

.experience-item8::before,
.education-item8::before {
  content: "";
  position: absolute;
  top: 0;
  left: -4px;
  width: 6px;
  height: 6px;
  border-radius: 80%;
  border: 2px solid rgb(5, 5, 93);
}

.scroll-container23 {
  overflow-x: auto;
  white-space: nowrap;
  width: 100%;
}

@media (max-width: 768px) {
  .experience-item8,
  .education-item8 {
    padding-left: 20px;
    border-left-width: 1px;
  }

  .experience-item8::before,
  .education-item8::before {
    width: 6px;
    height: 6px;
    left: -4px;
  }
}
@media (max-width: 768px) {
  .resume-left8 {
    padding: 18px;
  }

  .resume-right8 {
    padding: 18px;
  }

  .section-title8 {
    font-size: 20px;
  }
  .section-title1 {
    font-size: 20px;
  }

  .experience-item8 h3,
  .education-item8 h3 {
    font-size: 16px;
  }

  .experience-item8 h4,
  .education-item8 h4 {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .resume-section823 {
    margin-bottom: 18px;
  }

  .experience-item8,
  .education-item8 {
    margin-bottom: 10px;
  }

  .experience-item8 h3,
  .education-item8 h3 {
    font-size: 16px;
  }

  .experience-item8 h4,
  .education-item8 h4 {
    font-size: 16px;
  }

  .resume-section823 ul li {
    font-size: 14px;
  }
}

.hr41 {
  border: 0;
  border-top: 2px solid rgb(5, 5, 93);
  margin: 20px 12px;
  margin-left: 10px;
  width: 76%;
}

.resume-left8 .hr41 {
  width: 50%;
  margin-left: 12px;
  border: 2px solid rgb(5, 5, 93);
}

.footer8 {
  padding: 3px 0;
  margin-top: 20px;
  border-top: 1px solid rgb(5, 5, 93);
}

.footer-text8 {
  font-size: 16px;
  color: black;
  text-align: end;
  margin-right: 18px;
  margin-bottom: 2px;
}

.footer-link8 {
  color: #007bff;
  text-decoration: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Resume/Template/UseTemp2223.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,wBAAwB;EACxB,uBAAuB;EACvB,gCAAgC;EAChC,SAAS;AACX;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,uBAAuB;AACzB;AACA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,sBAAsB;EACtB,uBAAuB;EACvB,4DAA4D;EAC5D,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,UAAU;EACV,cAAc;AAChB;;AAEA;EACE;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;EACA;IACE,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;EACzB;AACF;;;EAGE;IACE;MACE,2BAA2B;MAC3B,kBAAkB;IACpB;IACA;MACE,YAAY;MACZ,gBAAgB;MAChB,uBAAuB;IACzB;EACF;;EAEA;IACE,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,qCAAqC;IACrC,wBAAwB;IACxB,gBAAgB;IAChB,4CAA4C;EAC9C;EACA;IACE,kCAAkC;EACpC;;AAEF;EACE,aAAa;EACb,6BAA6B;;EAE7B,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,qCAAqC;EACrC,wBAAwB;EACxB,gBAAgB;EAChB,4CAA4C;EAC5C,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,0BAA0B;EAC1B,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;;EAErB,uBAAuB;AACzB;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,eAAe;EACf,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;AACrB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;EACpC,gCAAgC,EAAE,kCAAkC;EACpE,8BAA8B,EAAE,oBAAoB;EACpD,eAAe,EAAE,0CAA0C;AAC7D;;AAEA;EACE,oCAAoC;EACpC,gCAAgC,EAAE,kCAAkC;EACpE,8BAA8B,EAAE,oBAAoB;AACtD;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY;EACZ,0BAA0B;EAC1B,yBAAyB;EACzB,eAAe;EACf,4DAA4D;EAC5D,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,4DAA4D;EAC5D,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,kCAAkC;AACpC;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,YAAY;AACd;AACA;EACE,YAAY;AACd;AACA;EACE,iBAAiB;EACjB,4DAA4D;EAC5D,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;AACA;;;;;;KAMK;;AAEL;EACE,iBAAiB;EACjB,4DAA4D;EAC5D,eAAe;EACf,aAAa;EACb,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,kCAAkC;EAClC,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;;IAEE,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;;IAEE,UAAU;IACV,WAAW;IACX,UAAU;EACZ;AACF;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;;IAEE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE,SAAS;EACT,mCAAmC;EACnC,iBAAiB;EACjB,iBAAiB;EACjB,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB","sourcesContent":[".resume-container-41 {\r\n  display: flex;\r\n  flex-direction: column;\r\n  padding: 20px;\r\n  width: 1000px !important;\r\n  justify-content: center;\r\n  align-items: flex-end !important;\r\n  margin: 0;\r\n}\r\n\r\n.resume41 {\r\n  color: black;\r\n}\r\n\r\n.bold-title8 {\r\n  font-weight: bold;\r\n}\r\n.bold8 {\r\n  font-weight: 700;\r\n  font-size: 14px;\r\n}\r\n.button-container123 {\r\n  width: 78%;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  margin: 10px 0;\r\n  padding: 0 0rem 0 11rem;\r\n}\r\n.bk8 {\r\n  justify-self: start;\r\n}\r\n\r\n.db823 {\r\n  justify-self: end;\r\n}\r\n.db823 {\r\n  background-color: #474559 !important;\r\n  color: white !important;\r\n  border: 2px solid black;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 8px;\r\n  margin-left: 18rem;\r\n  text-wrap: nowrap;\r\n}\r\n.back-button23 {\r\n  position: relative;\r\n  background-color: #474559 !important;\r\n  color: #fff !important;\r\n  border: 2px solid white;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  font-size: large;\r\n  margin-top: 8px;\r\n  left: 12px;\r\n  display: block;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .db823 {\r\n    padding-top: 0px !important;\r\n    margin-left: 0px;\r\n  }\r\n  .button-container123 {\r\n    padding: 0px;\r\n    margin-left: 0px;\r\n    align-items: flex-start;\r\n  }\r\n}\r\n\r\n\r\n  @media (min-width: 768px) and (max-width: 1024px) {\r\n    .db823 {\r\n      padding-top: 0px !important;\r\n      margin-left: 264px;\r\n    }\r\n    .button-container123 {\r\n      padding: 0px;\r\n      margin-left: 0px;\r\n      align-items: flex-start;\r\n    }\r\n  }\r\n\r\n  .resume41 {\r\n    display: inline-block;\r\n    flex-wrap: wrap;\r\n    width: 100%;\r\n    max-width: 800px;\r\n    /* border: 1px solid rgb(5, 5, 93); */\r\n    /* border-radius: 8px; */\r\n    overflow: hidden;\r\n    box-shadow: -1px 2px 24px rgba(0, 0, 0, 0.1);\r\n  }\r\n  .resume-container-8 {\r\n    align-items: flex-start !important;\r\n  }\r\n\r\n.resume41 {\r\n  display: flex;\r\n  justify-content: space-around;\r\n\r\n  flex-wrap: wrap;\r\n  width: 100%;\r\n  max-width: 800px;\r\n  /* border: 1px solid rgb(5, 5, 93); */\r\n  /* border-radius: 8px; */\r\n  overflow: hidden;\r\n  box-shadow: -1px 2px 24px rgba(0, 0, 0, 0.1);\r\n  color: black;\r\n}\r\n\r\n.name41 {\r\n  text-align: left;\r\n  font-size: 3.6em;\r\n  margin-top: 10px;\r\n  font-weight: bold;\r\n  color: black;\r\n  text-transform: uppercase;\r\n  margin-left: 30px;\r\n}\r\n.tc8 {\r\n  text-align: left;\r\n  font-size: 1.6em;\r\n  font-weight: 300;\r\n  color: black;\r\n  text-transform: capitalize;\r\n  margin-left: 30px;\r\n}\r\n.tc8::first-letter {\r\n  text-transform: uppercase;\r\n}\r\n.jobtitle {\r\n  display: inline-block;\r\n\r\n  /* or display: block; */\r\n}\r\n.jobtitle23::first-letter {\r\n  text-transform: uppercase !important;\r\n}\r\n\r\n.resume-left41 {\r\n  background-color: white;\r\n  position: relative;\r\n  left: 11px;\r\n  color: black;\r\n  justify-content: space-between;\r\n  padding: 20px;\r\n  text-align: left;\r\n  border: 3px solid rgb(5, 5, 93);\r\n  margin-top: 22px;\r\n  position: relative;\r\n}\r\n\r\n.section-title41 {\r\n  font-size: 17px;\r\n  margin-bottom: 9px;\r\n  text-transform: uppercase;\r\n  font-weight: 550;\r\n  color: black;\r\n}\r\n\r\n.resume-right823 {\r\n  background-color: white;\r\n  color: black;\r\n  padding: 20px;\r\n  text-align: left;\r\n  margin-top: 28px;\r\n  text-wrap: wrap;\r\n}\r\n.p23 {\r\n  font-family: 'Montserrat', sans-serif;\r\n  font-size: 14px;\r\n  color: black;\r\n  word-wrap: break-word;\r\n  text-align: justify;\r\n}\r\n.bold8 {\r\n  font-weight: bold;\r\n}\r\n.resume-section823 {\r\n  margin-bottom: 14px;\r\n  margin-top: 50px;\r\n}\r\n\r\n.Contact-section {\r\n  margin-top: 200px;\r\n  /* padding: 20px; */\r\n  width: 100%;\r\n  font-size: 13px;\r\n  margin-bottom: 10px;\r\n  text-align: left;\r\n  overflow-wrap: break-word !important;\r\n  word-wrap: break-word !important; /* Alternative for compatibility */\r\n  white-space: normal !important; /* Allows wrapping */\r\n  max-width: 100%; /* Prevents the section from overflowing */\r\n}\r\n\r\n.Contact-section .d-flex23 {\r\n  overflow-wrap: break-word !important;\r\n  word-wrap: break-word !important; /* Alternative for compatibility */\r\n  white-space: normal !important; /* Allows wrapping */\r\n}\r\n\r\n.Contact-section .section-title8 {\r\n  font-size: 19px;\r\n  font-weight: bold;\r\n  text-transform: uppercase;\r\n  color: black;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.Contact-section p {\r\n  font-size: 14px;\r\n  color: black;\r\n  line-height: 1.6;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.section-title8 {\r\n  font-size: 1.2em;\r\n  margin-bottom: 8px !important;\r\n  color: black;\r\n  margin-top: 0px !important;\r\n  text-transform: uppercase;\r\n  font-size: 19px;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n}\r\n\r\n.section-title1 {\r\n  font-size: 19px;\r\n  margin-bottom: 20px;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-weight: bold;\r\n  color: black;\r\n  text-transform: uppercase;\r\n  margin-top: 28px;\r\n}\r\n\r\n.experience-item8,\r\n.education-item823 {\r\n  margin-bottom: 18px;\r\n}\r\n\r\n.resume-section823 ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  margin: 0;\r\n}\r\n\r\n.resume-section823 ul li {\r\n  margin-bottom: 8px;\r\n  align-items: center;\r\n  font-size: 14px;\r\n  color: black;\r\n  text-wrap: wrap;\r\n  text-align: justify;\r\n  word-break: break-word;\r\n  /* display:flex; */\r\n}\r\n\r\n.resume-section823 ul li span {\r\n  margin-left: 14px;\r\n}\r\n\r\n.resume-section823 ul li ::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 8px;\r\n  left: -20px;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 80%;\r\n  border: 2px solid black !important;\r\n}\r\n.icon8 {\r\n  height: 17px;\r\n  width: 17px;\r\n  margin-right: 3px;\r\n  color: black;\r\n}\r\n.subheading8 {\r\n  color: black;\r\n}\r\n.p123 {\r\n  font-weight: bold;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 14px;\r\n  margin: 4px 0;\r\n  text-align: justify;\r\n  text-wrap: wrap;\r\n}\r\n/* .p11 {\r\n    font-weight: bold;\r\n    font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n    font-size: 14px;\r\n    margin: 4px 0;\r\n  \r\n  } */\r\n\r\n.p11 {\r\n  font-weight: bold;\r\n  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;\r\n  font-size: 14px;\r\n  margin: 4px 0;\r\n  display: flex;\r\n}\r\n\r\n.title1 {\r\n  text-wrap: nowrap;\r\n}\r\n.span23 {\r\n  font-size: 14px;\r\n  font-weight: normal;\r\n  line-height: 3px;\r\n  color: black;\r\n  text-wrap: wrap;\r\n  text-align: justify;\r\n}\r\n\r\n.profile-pic41 img {\r\n  width: 160px;\r\n  height: 160px;\r\n  border-radius: 0;\r\n  border: 2px solid rgb(5, 5, 93);\r\n  margin: 10px auto;\r\n  justify-content: center !important;\r\n  align-items: center !important;\r\n  object-fit: cover;\r\n  display: block;\r\n  filter: contrast(2);\r\n}\r\n\r\n.profile-pic41 {\r\n  margin-left: 110px;\r\n  position: absolute;\r\n  z-index: 1;\r\n}\r\n.experience-item8,\r\n.education-item8 {\r\n  position: relative;\r\n  padding-left: 28px;\r\n  border-left: 2px solid rgb(5, 5, 93);\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.experience-item8::before,\r\n.education-item8::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  top: 0;\r\n  left: -4px;\r\n  width: 6px;\r\n  height: 6px;\r\n  border-radius: 80%;\r\n  border: 2px solid rgb(5, 5, 93);\r\n}\r\n\r\n.scroll-container23 {\r\n  overflow-x: auto;\r\n  white-space: nowrap;\r\n  width: 100%;\r\n}\r\n\r\n@media (max-width: 768px) {\r\n  .experience-item8,\r\n  .education-item8 {\r\n    padding-left: 20px;\r\n    border-left-width: 1px;\r\n  }\r\n\r\n  .experience-item8::before,\r\n  .education-item8::before {\r\n    width: 6px;\r\n    height: 6px;\r\n    left: -4px;\r\n  }\r\n}\r\n@media (max-width: 768px) {\r\n  .resume-left8 {\r\n    padding: 18px;\r\n  }\r\n\r\n  .resume-right8 {\r\n    padding: 18px;\r\n  }\r\n\r\n  .section-title8 {\r\n    font-size: 20px;\r\n  }\r\n  .section-title1 {\r\n    font-size: 20px;\r\n  }\r\n\r\n  .experience-item8 h3,\r\n  .education-item8 h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .experience-item8 h4,\r\n  .education-item8 h4 {\r\n    font-size: 16px;\r\n  }\r\n}\r\n\r\n@media (max-width: 480px) {\r\n  .resume-section823 {\r\n    margin-bottom: 18px;\r\n  }\r\n\r\n  .experience-item8,\r\n  .education-item8 {\r\n    margin-bottom: 10px;\r\n  }\r\n\r\n  .experience-item8 h3,\r\n  .education-item8 h3 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .experience-item8 h4,\r\n  .education-item8 h4 {\r\n    font-size: 16px;\r\n  }\r\n\r\n  .resume-section823 ul li {\r\n    font-size: 14px;\r\n  }\r\n}\r\n\r\n.hr41 {\r\n  border: 0;\r\n  border-top: 2px solid rgb(5, 5, 93);\r\n  margin: 20px 12px;\r\n  margin-left: 10px;\r\n  width: 76%;\r\n}\r\n\r\n.resume-left8 .hr41 {\r\n  width: 50%;\r\n  margin-left: 12px;\r\n  border: 2px solid rgb(5, 5, 93);\r\n}\r\n\r\n.footer8 {\r\n  padding: 3px 0;\r\n  margin-top: 20px;\r\n  border-top: 1px solid rgb(5, 5, 93);\r\n}\r\n\r\n.footer-text8 {\r\n  font-size: 16px;\r\n  color: black;\r\n  text-align: end;\r\n  margin-right: 18px;\r\n  margin-bottom: 2px;\r\n}\r\n\r\n.footer-link8 {\r\n  color: #007bff;\r\n  text-decoration: none;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
